import { Map } from '@/map';
import { Marker, Polyline, Popup, useMap } from 'react-leaflet';
import searchBusDir from '@/api/searchBusDir';
import getBusesPos, { type BusPositionData } from '@/api/getBusesPos';
import { useEffect, useState } from 'react';
import getPath from '@/api/getPath';

export default function LinePage() {
	const params = new URLSearchParams(window.location.search);
	const linha = params.get('linha');
	const sentido = params.get('sentido');

	const [isCircular, setIsCircular] = useState(false);
	const [busId, setBusId] = useState(0);
	const [termNames, setTermNames] = useState({ start: '', end: '' });
	const [busPositions, setBusPositions] = useState([] as BusPositionData[]);
	const [linePath, setLinePath] = useState([] as [number, number][]);

	const fetchBusId = async () => {
		if (!linha || !sentido) return;

		const response = await searchBusDir(linha, parseInt(sentido));
		if (!response || response.length === 0) return;

		const result = response[0];
		if (!result) return;

		setIsCircular(result.lc);
		const id = result.cl;

		const terminal1 = result.sl === 1 ? result.ts : result.tp;
		const terminal2 = result.sl === 1 ? result.tp : result.ts;
		setBusId(id);
		setTermNames({ start: terminal1, end: terminal2 });
	};

	const fetchBusPositions = async () => {
		if (busId === 0) return;

		const positions = await getBusesPos(busId);
		if (!positions) return;

		setBusPositions(positions);
	};

	const fetchLinePath = async () => {
		if (!linha || !sentido) return;

		const sent = isCircular ? 1 : parseInt(sentido);
		const path = await getPath(linha, sent);

		if (!path) return;
		setLinePath(path);
	};

	const renderBusPositions = () => {
		return busPositions.map((bus) => (
			<Marker key={bus.p} position={[bus.py, bus.px]}>
				<Popup>
					Prefixo: {bus.p} <br />
				</Popup>
			</Marker>
		));
	};

	async function adjustViewToFit() {
		if (linePath.length === 0) return;

		const bounds = [
			linePath[0], linePath[linePath.length - 1]
		] as [number, number][];
		const map = useMap();
		map.fitBounds(bounds);
	}

	async function initialize() {
		await fetchBusId();
		await fetchBusPositions();
		await fetchLinePath();
		await adjustViewToFit();
	}

	useEffect(() => {
		initialize();
	}, [busId]);

	useEffect(() => {
		const interval = setInterval(() => {
			fetchBusPositions();
		}, 5000);

		return () => clearInterval(interval);
	}, [busId]);

	return (
		<div className="page-container">
			<div className="line-info">
				<p>Linha {linha}</p>
				<p>
					{termNames.start} ► {termNames.end}
				</p>
				<button className="reload-button" onClick={fetchBusPositions}>
					🔃
				</button>
			</div>
			<Map>
				{renderBusPositions()}
				<Polyline positions={linePath} color="blue" />
			</Map>
		</div>
	);
}
